import { Inject, ISimpleControllerConfiguration, SimpleBaseController } from "@denishussar/html5-game-engine";
import { BackgroundContainer, BackgroundNames } from "./Controllers/Common/BackgroundContainer";
import { ScreenManagerController } from "./Controllers/Screens/ScreenManager";
import { GameModel } from "./Models/GameModel";

/**
 * Contains content which must be blured on modals appearing
 */
export class BlurContentController extends SimpleBaseController {
    $model: GameModel;

    constructor(
        @Inject private options: {},
    ){
        super("BlurContentController");
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        return {
            childControllers: {
                backgroundContainer: {
                    controller: BackgroundContainer,
                    model: this.$model,
                    options: {
                        name: BackgroundNames.first
                    }
                },
                screenController: {
                    controller: ScreenManagerController,
                    model: this.$model,
                },
            },
        }
    }

    protected onInitialize(): void {
        
    }
}
